__turbopack_context__.v({
  "panel": "UsageGuidancePanel-module-scss-module__c-foBa__panel",
  "personaCard": "UsageGuidancePanel-module-scss-module__c-foBa__personaCard",
});
